import { render, staticRenderFns } from "./EditTintStyle.vue?vue&type=template&id=77284c8b&"
import script from "./EditTintStyle.vue?vue&type=script&lang=js&"
export * from "./EditTintStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports